import { HTMLAttributes, type FC } from "react";
import { Button, ButtonProps } from "@mantine/core";
import tButton, { VariantButtonProps } from "./TButton.helper";
import Link from "next/link";
import { trimStart } from "lodash";

// -----------------------------------------------------------------------

export type TButtonProps = Omit<ButtonProps, "size"> &
  HTMLAttributes<HTMLButtonElement> &
  VariantButtonProps & {
    href?: string;
    target?: string;
    type?: "button" | "submit" | "reset";
    prefetch?: boolean;
  };

// Regex pattern for validate external URL
const externalUrlPattern =
  /^(https?:)?\/\/(?:localhost|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6})(:\d+)?(?:\/.*)?$/;

// Return validated href for button component
const validateHref = (href: string) => {
  if (externalUrlPattern.test(href)) return href;

  // remove all "/" from starting of the string
  return "/" + trimStart(href, "/");
};

const TButton: FC<TButtonProps> = (props) => {
  const {
    children,
    href,
    target,
    className,
    variant,
    size,
    radius,
    id,
    type,
    disabled,
    prefetch,
    ...other
  } = props;

  if (!!href) {
    return (
      <Button
        id={id}
        target={target}
        className={tButton({
          variant,
          size,
          radius,
          disabled,
          class: className,
        })}
        component={Link}
        href={validateHref(href)}
        disabled={disabled}
        prefetch={prefetch}
      >
        {children}
      </Button>
    );
  }

  return (
    <Button
      id={id}
      className={tButton({ variant, size, radius, disabled, class: className })}
      type={type}
      disabled={disabled}
      {...other}
    >
      {children}
    </Button>
  );
};

export default TButton;
